import { useTranslation } from "react-i18next";
import HeroSection from "../../components/HeroSection/HeroSection";
import "./Services.css";

function Services() {
  const { t } = useTranslation();

  const services = [
    {
      id: 1,
      title: t("services.express.title"),
      description: t("services.express.desc"),
      icon: "✈️"
    },
    {
      id: 2,
      title: t("services.sea.title"),
      description: t("services.sea.desc"),
      icon: "🚢"
    },
    {
      id: 3,
      title: t("services.personal.title"),
      description: t("services.personal.desc"),
      icon: "📦"
    },
    {
      id: 4,
      title: t("services.customs.title"),
      description: t("services.customs.desc"),
      icon: "📋"
    }
  ];

  return (
    <main className="services-page">
      <HeroSection 
        title={t("nav.services")}
        subtitle="Dịch vụ vận chuyển quốc tế chuyên nghiệp"
      />

      <section className="services-content">
        <div className="services-container">
          <div className="services-intro">
            <h2>Dịch vụ của chúng tôi</h2>
            <p>
              Fast Express cung cấp các dịch vụ vận chuyển quốc tế toàn diện, 
              đáp ứng mọi nhu cầu logistics của bạn với giá cạnh tranh và chất lượng tốt nhất.
            </p>
          </div>

          <div className="services-grid">
            {services.map((service) => (
              <div key={service.id} className="service-item">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

export default Services;
